//@flow
import React, { Component } from 'react';
import { Desktop } from '../../../components/Responsive';
import { ModelListTh } from '../../../components/ModelListStyles';
import Switch from '../../../components/Switch';
import DefaultModelRowTr from '../../../modules/CrudTable/components/DefaultModelRowTr';

type Props = {
  orderBy: { amount: number => void },
  orderState: { amount: number }
};

export default class TableHeader extends Component<Props> {
  handleClick = (orderState: number) => {
    this.props.orderBy.amount(orderState);
  };
  render() {
    return (
      <DefaultModelRowTr>
        <Desktop>
          <ModelListTh>Currency</ModelListTh>
        </Desktop>
        <ModelListTh>Date</ModelListTh>
        <ModelListTh right>
          <Switch
            text={'Amount'}
            orderState={this.props.orderState.amount}
            handleClick={orderState => this.handleClick(orderState)}
          />
        </ModelListTh>
        <ModelListTh right>Status</ModelListTh>
      </DefaultModelRowTr>
    );
  }
}
